import CustomButton from "Components/Custom/CustomButton";
import { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { ErrorToast } from "utils/toast";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (img: any) => void;
}

const SignatureModal = ({ isOpen, onClose, onSave }: Props) => {
  const sigRef = useRef<any>();

  const handleClearSignature = () => {
    sigRef.current.clear();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      size="md"
      contentClassName="br-7"
    >
      {/* Header */}
      <ModalHeader
        toggle={onClose}
        className="fw-medium fs-16 text-black2D p-3 bg-greyF5 br-tl-7 br-tr-7"
      >
        Add Signature
      </ModalHeader>

      {/* Body */}
      <ModalBody className="p-4 d-flex justify-content-center align-items-center">
        <SignatureCanvas
          ref={sigRef}
          penColor="black"
          canvasProps={{
            className: "signatureCanvas",
          }}
        />
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center gap-5 mt-0 pt-0">
        {/* BUTTON */}
        <CustomButton
          className="bg-grey89 text-white br-7 px-5"
          type="button"
          text="Clear"
          onClick={handleClearSignature}
        />
        <CustomButton
          className="bg-primary text-white br-7 px-5"
          type="button"
          text="Save"
          onClick={() => {
            if (!sigRef.current || sigRef.current.isEmpty()) {
              ErrorToast("Please provide a signature before saving.");
              return;
            }
            const dataURL = sigRef.current.getCanvas().toDataURL("image/png");
            console.log("Signature Data URL:", dataURL);

            onSave(dataURL);
          }}
        />
      </ModalFooter>
    </Modal>
  );
};

export default SignatureModal;
